var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 10.694V5.306c0-.477-.254-.917-.667-1.155L8.667 1.457a1.334 1.334 0 00-1.334 0L2.667 4.151A1.334 1.334 0 002 5.306v5.389c0 .476.254.916.667 1.154l4.666 2.694c.413.238.921.238 1.334 0l4.666-2.694c.413-.238.667-.678.667-1.155z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.72v-3.713",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.782 5.817l-.433.25.5.866.433-.25-.25-.433-.25-.433zm3.288-.744a.5.5 0 00-.5-.866l.25.433.25.433zM11.032 6.25l.25.433 2.788-1.61-.25-.433-.25-.433-2.788 1.61.25.433z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.362 4.745L4.97 6.25",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootEntity);
export default __webpack_public_path__ + "static/media/root-entity.503332388a72daec37de33f5df95c900.svg";
export { ForwardRef as ReactComponent };